import { Input, Label } from 'reactstrap';

type SingleCheckboxInputProps = {
    checked: boolean;
    checkboxCustomCss?: string;
    containerCustomCss?: string;
    disabled?: boolean;
    id: string;
    label: string;
    labelCustomCss?: string;
    invalid?: boolean;
    onChange: (event) => void;
    value: string;
}

const SingleCheckboxInput = ({ checked, checkboxCustomCss, containerCustomCss, disabled, id, label, labelCustomCss, invalid, onChange, value }: SingleCheckboxInputProps) => {
    return <div className={containerCustomCss ?? "d-inline-block" }>
        <Input
            checked={checked}
            className= {checkboxCustomCss ?? 'clickable me-2'}
            disabled={disabled}
            id={id}
            invalid={invalid === true}
            name={id}
            onChange={onChange}
            type="checkbox"
            value={value}
        />
        <Label
            className={labelCustomCss ?? 'clickable mx-2'}
            for={id}
            check
        >
            {label}
        </Label>
    </div>
}

export default SingleCheckboxInput;